import defaultStyled from '../../styled-components.mjs';

const OverlayContainer = defaultStyled.div`
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    transition: all 0.2s cubic-bezier(0.33, 0, 0.2, 1);
    &.leave {
        opacity: 0 !important;
    }
    &.bg-black {
        background-color: #000;
    }
    &.bg-white {
        background-color: #fff;
    }
`;

export { OverlayContainer };
